import { useRouter } from 'next/router'
import { MapListWithFallback as View } from 'ui-components'
import { getUserLink } from 'utils'

import { useIsWorkspaceMember } from '~workspace/hooks/useIsWorkspaceMember'
import { useIsWorkspaceGuest } from '~workspace/hooks/useWorkspaceGuest'
import { useSearchMapsInCurrentWorkspace } from '~workspace/queries/useSearchMaps'
import { Map } from '~workspace/types/__generated/gql/graphql'

import { CreateMapButton } from 'create-map-button'
import { useGetCurrentWorkspace } from '~workspace/queries/useGetWorkspaceById'
import { Pagination } from './Pagination'

/**
 * @description The link is added to mapstack.io production
 */
export const SAMPLE_MAP_URL =
  'https://mapstack-prod-public-resources.s3.amazonaws.com/sample-data/us-counties.geojson'

export const MapList = (props) => {
  const {} = props

  const router = useRouter()

  const isWorkspaceMember = useIsWorkspaceMember()
  const isWorkspaceGuest = useIsWorkspaceGuest()

  const { data: currentWorkspace } = useGetCurrentWorkspace()
  const { data, isLoading } = useSearchMapsInCurrentWorkspace()

  const isSearching = router.query.query?.length || !!router.query.tags?.length
  const noResultsText = isSearching ? 'No maps found' : undefined

  return (
    <View
      isWorkspaceGuest={isWorkspaceGuest}
      noResultsText={noResultsText}
      loading={isLoading}
      defaultMapUrl={SAMPLE_MAP_URL}
      canCreateMap={isWorkspaceMember}
      maps={(data?.items || []) as Map[]}
      getMapAvatar={(map) =>
        map.creator
          ? {
              image: map.creator.avatar!,
              name: [map.creator.firstName, map.creator.lastName].join(' '),
              href: getUserLink({
                userId: map.creator.id,
                firstName: map.creator.firstName!,
                lastName: map.creator.lastName!
              }),
              updatedAt: map.createdAt
            }
          : undefined
      }
      slots={{ Pagination, CreateMapButton }}
      slotProps={{
        CreateMapButton: {
          currentWorkspace
        }
      }}
    />
  )
}
